import React, { useState } from "react";
import { Plus } from "lucide-react";
import VoiceRecordButton from "../voice/VoiceRecordButton";
import Tooltip from "./Tooltip";

interface FloatingActionButtonProps {
  onClick: () => void;
  shortcutKey?: string;
  isRecording?: boolean;
  isProcessingVoice?: boolean;
  recordingDuration?: number;
  analyserNode?: AnalyserNode | null;
  showVoiceNoResults?: boolean;
  onStartRecording?: () => void;
  onStopRecording?: () => void;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({
  onClick,
  shortcutKey = "N",
  isRecording = false,
  isProcessingVoice = false,
  recordingDuration = 0,
  analyserNode = null,
  showVoiceNoResults = false,
  onStartRecording,
  onStopRecording,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-[25] flex items-center gap-3">
      {onStartRecording && onStopRecording && (
        <VoiceRecordButton
          isRecording={isRecording}
          isProcessing={isProcessingVoice}
          duration={recordingDuration}
          analyserNode={analyserNode}
          showNoResults={showVoiceNoResults}
          onStartRecording={onStartRecording}
          onStopRecording={onStopRecording}
        />
      )}

      <Tooltip content={`Add Task (${shortcutKey})`} placement="top" align="end">
        <button
          onClick={onClick}
          onMouseDown={() => setIsActive(true)}
          onMouseUp={() => setIsActive(false)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => {
            setIsActive(false);
            setIsHovered(false);
          }}
          onFocus={() => setIsHovered(true)}
          onBlur={() => setIsHovered(false)}
          data-shortcut="N"
          className="group relative w-14 h-14 md:w-16 md:h-16 bg-warm-blue hover:bg-warm-blue-dark rounded-2xl shadow-soft-lg hover:shadow-soft-md transition-all"
          style={{
            transform: isActive
              ? "scale(0.92) rotate(-2deg)"
              : isHovered
                ? "scale(1.08) rotate(2deg)"
                : "scale(1)",
            transition: "transform 200ms cubic-bezier(0.22, 1, 0.36, 1), background-color 150ms, box-shadow 150ms",
          }}
          aria-label="Add Task"
        >
          <Plus
            className="absolute inset-0 m-auto text-white transition-transform duration-200"
            style={{ transform: isHovered ? "rotate(90deg)" : "rotate(0deg)" }}
            size={26}
            strokeWidth={2.5}
          />
        </button>
      </Tooltip>
    </div>
  );
};

export default FloatingActionButton;
